export default __webpack_public_path__ + "static/media/jira.ac05c707.png";